import styled from "@emotion/styled";


export const FlexSpaceBetween = styled("div")(({ theme }) => ({
    display: "flex" ,
    justifyContent : "space-between" ,
    // alignItems : "center" , 
}));